import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Link, useParams } from 'react-router-dom';
import { LOT_STATUS } from 'constants/common';
import UserAvatarCircle from 'components/UserAvatarCircle/UserAvatarCircle';

import './ConversationHeader.scss';
import { useStores } from 'stores';

const ConversationHeader = observer(() => {
  const {
    messageStore: { isLoading, conversations, getConversationById },
  } = useStores();
  const { id } = useParams();
  const [currentConversation, setCurrentConversation] = useState(null);
  const [conversationDetails, setConversationDetails] = useState({ author: '', lotName: '', lotId: '' });
  const [lotStatus, setLotStatus] = useState("");

  const getNewConversation = () => {
    const newConversation = sessionStorage.getItem('newConversationData');

    if (newConversation) {
      const parsedConversation = JSON.parse(newConversation);
      return { ...parsedConversation, lotTitle: parsedConversation.title };
    }

    return null;
  };

  const truncateLotName = (lotTitle, maxLength = 40) => {
    if (lotTitle.length > maxLength) {
      return `${lotTitle.substring(0, maxLength).trim()} ...`;
    }

    return lotTitle;
  };

  useEffect(() => {
    const parsedId = parseInt(id, 10);
    const conversation = parsedId === -1 ? getNewConversation() : getConversationById(parsedId);

    if (!conversation) {
      setCurrentConversation(null);
      return;
    }

    setCurrentConversation(conversation);
    setConversationDetails({
      author: `${conversation.userFirstName} ${conversation.userLastName}`,
      lotName: truncateLotName(conversation.lotTitle),
      lotId: conversation.lotId,
    });
  }, [id, conversations]);

  useEffect(() => {
      if (currentConversation && conversations.length > 0) {
        setLotStatus(currentConversation.lotStatus);
      }
    }, [currentConversation, conversations]);

  const { author, lotName, lotId } = conversationDetails;

  if (id === undefined || isLoading) {
    return null;
  }

  return (
    <div className="conversationHeader">
      {!currentConversation ? (
        <div className="inactiveLot">Lot is inactive</div>
      ) : (
        <>
          <UserAvatarCircle
            className="avatar"
            firstName={currentConversation.userFirstName}
            lastName={currentConversation.userLastName}
            size={32}
          />
          <div className="author">{author}</div>
          <div className="link">
            <span className={
              lotStatus === LOT_STATUS.DELETED || lotStatus === LOT_STATUS.DEACTIVATED
                ? 'inactiveLot'
                : ''
            }
            >
            {lotStatus === LOT_STATUS.DELETED
              ? 'Removed Lot:'
              : lotStatus === LOT_STATUS.DEACTIVATED
              ? 'Deactivated Lot:'
              : 'Lot:'}
            </span>
            <Link
              to={`/lot/${lotId}`}
              className={
                lotStatus === LOT_STATUS.DELETED || lotStatus === LOT_STATUS.DEACTIVATED
                  ? 'inactiveLot'
                  : ''
              }
            >
              {lotName}
            </Link>
          </div>
        </>
      )}
    </div>
  );
});

export default ConversationHeader;
